import {createContext} from 'react'

export const FacebookMessageConfirmOrderContext = createContext()
